import React from 'react';
import { Box } from '@mui/material';
import VideoPlayer from 'components/VideoPlayer';
import ZoomAction from './ZoomAction';
import WatchLiveButton from './WatchLiveButton';
import { Account } from 'types/Account';
import CameraPlayerBar from './CameraPlayerBar';

function PlaybackCameraPlayer({
  token,
  camName,
  url,
  onErrorPlaylist,
  accountSelected,
}: {
  token: string;
  camName: string;
  url: string;
  onErrorPlaylist: () => void;
  accountSelected: Account;
}) {
  const [zoom, setZoom] = React.useState(1);
  const onZoomChange = React.useCallback((rZoom: number) => {
    setZoom(rZoom);
  }, []);

  const sources = React.useMemo(() => {
    if (url) {
      return [
        {
          src: url,
        },
      ];
    }
  }, [url]);

  return (
    <Box
      overflow="hidden"
      flex="1 1 auto"
      role="region"
      position="relative"
      display="flex"
      maxHeight="662px"
      borderRadius="5px"
    >
      {accountSelected.isSIMCloud ? (
        <VideoPlayer.HLS
          {...{
            sources,
            onZoomChange,
            zoom,
            onErrorPlaylist,
            authorization: token,
          }}
          enableZoom
          key={`channel-${camName}`}
          id={`channel-${camName}`}
          autoplay
          fill
          noControlBar
          preload="auto"
        />
      ) : (
        <VideoPlayer.MJPEG id={`channel-playback-${camName}`} url={url} />
      )}
      <CameraPlayerBar {...{ camName, accountSelected }} />
      <WatchLiveButton />
      <ZoomAction {...{ zoom, setZoom }} />
    </Box>
  );
}

export default PlaybackCameraPlayer;
